import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import ProtectedRoute from './utils/protectRout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import FaqsPage from '@content/pages/faqs';
import AdDetailsPage from 'src/content/pages/banner/componate/bannerDetails';
import LawyerPageDeshboard from 'src/content/pages/lawyer/components/lawyerDeshboard';
import cases from 'src/content/pages/Cases';
import path from 'path';
import CaseDocuments from
  "src/content/pages/Cases/Documents";
import AdminStaff from 'src/content/pages/adminstaff';
import Clients from 'src/content/pages/client';
import StaffDetailsCard from 'src/content/pages/adminstaff/components/datils';
import ClientDetails from 'src/content/pages/client/clientDetails';
import DeleteAccount from 'src/content/pages/auth/deleteAccount';
import SingUp from 'src/content/pages/landingPage/auths/singUp';
import HomeScreen from 'src/content/pages/landingPage/auths/homePage';
import { getRole } from 'src/utils/session';
import RoleProtectedRoute from 'src/utils/RoleProtectedRoute';
import SpecializationsDetail from 'src/content/pages/specializations/specializationsDtail';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages
const role = getRole()
const isAllowed = role?.[0] === "Admin" || role?.[0] === "Lawyer";
// Auth
const LoginAuth = Loader(
  lazy(() => import('src/content/pages/auth/loginAuth'))
);

const SignUpAuth = Loader(lazy(() => import('src/content/pages/auth/signUp')));
const ForgotPassword = Loader(
  lazy(() => import('src/content/pages/auth/forgetPassword'))
);
const VerifyOtp = Loader(
  lazy(() => import('src/content/pages/auth/verifyOtp'))
);
const ResetPassword = Loader(
  lazy(() => import('src/content/pages/auth/resetPassword'))
);

const FaqsPages = Loader(lazy(() => import('src/content/pages/faqs/index')))
const Specializations = Loader(lazy(() => import('src/content/pages/specializations/index')))
const Consultations = Loader(lazy(() => import('src/content/pages/consultations/index')))
const ConsultationDetails = Loader(lazy(() => import('src/content/pages/consultations/details')))
const UserProfile = Loader(lazy(() => import('src/content/pages/userProfile/index')))
const LawyerManagement = Loader(lazy(() => import('src/content/pages/lawyer/index')))
const BannerManagement = Loader(lazy(() => import('src/content/pages/banner/index')))
const Notifications = Loader(lazy(() => import('src/content/pages/notification/index')));
const DocumentPage  = Loader(lazy(()=>import('src/content/pages/consultations/documentPage')))

const Cases = Loader(lazy(() => import('src/content/pages/Cases/index')));
const CaseDetails = Loader(
  lazy(() => import('src/content/pages/Cases/component/details'))
);


// Dashboards

const Crypto = Loader(lazy(() => import('src/content/dashboards/Crypto')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes: RouteObject[] = [
  {
    path: '/account',
    element: <BaseLayout />,
    children: [
      {
        path: 'login',
        element: <LoginAuth />
      },
      {
        path: 'sign-Up',
        element: <SignUpAuth />
      },
      {
        path: 'forgotPassword',
        element: <ForgotPassword />
      },
      {
        path: 'verifyOtp',
        element: <VerifyOtp />
      },
      {
        path: 'resetPassword',
        element: <ResetPassword />
      },
            {
        path: 'delete-account',
        element: <DeleteAccount />
      },
      {
        path:'signUp',
        element:<SingUp/>
      }
    ]
  },
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <LoginAuth />
      },
      {
        path: 'overview',
        element: <Navigate to="/" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboards',
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute roles={["Admin","AdminStaff","Lawyer","Client"]}>
        <SidebarLayout />
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        element:
        ( <Navigate to="crypto" replace />)
      },
      {
        path: 'crypto',
        element: <Crypto />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },

      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          }
        ]
      }
    ]
  },
  {
    path: 'Page',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="transactions" replace />
      },

      {
        path: 'faq',
        element: <FaqsPages />
      },
      {
        path: 'specializations',
        element: 
       ( <RoleProtectedRoute roles={["Admin", "AdminStaff"]}>
        <Specializations />
        </RoleProtectedRoute>)
      },
      {
        path: 'consultations',
        element: <Consultations />
      },
      {
        path: 'consultations-Details/:id',
        element: <ConsultationDetails />
      },
      {
        path: 'userProfile',
        element: <UserProfile />
      },
      {
        path: 'lawyer',
        element: (<RoleProtectedRoute roles={["Admin", "AdminStaff"]}> <LawyerManagement /> </RoleProtectedRoute>)
      },
      {
        path: 'lawyerDashboard/:id',
        element: (<RoleProtectedRoute roles={["Admin", "AdminStaff"]}> <LawyerPageDeshboard /> </RoleProtectedRoute>)
      },
      {
        path: 'banners',
        element: (<RoleProtectedRoute roles={["Admin", "AdminStaff"]}> <BannerManagement /> </RoleProtectedRoute>)
      },
      {
        path: 'AdDetails/:id',
        element: (<RoleProtectedRoute roles={["Admin", "AdminStaff"]}> <AdDetailsPage /> </RoleProtectedRoute>)
      },
      {
        path: 'notifications',
        element: (<RoleProtectedRoute roles={["Admin", "AdminStaff"]}> <Notifications /> </RoleProtectedRoute>)
      },
      {
        path: "documents/:id",
        element: <DocumentPage/>
      },

      {
        path: 'cases',
        element: <Cases />
      },
      {
         path: 'cases-details/:id',
        element: <CaseDetails/>

      },
      {
        path: 'cases/:id/documents',
        element: <CaseDocuments />
},
   {
        path: 'admin-staff',
        element: (<RoleProtectedRoute roles={["Admin"]}> <AdminStaff /> </RoleProtectedRoute>)
},
{
        path: 'client',
        element: (<RoleProtectedRoute roles={["Admin","AdminStaff"]}> <Clients/> </RoleProtectedRoute>)
},
  {
        path: 'client-datail/:id',
        element: (<RoleProtectedRoute roles={["Admin","AdminStaff"]}> <ClientDetails/> </RoleProtectedRoute>)
},

  {
        path: 'staff-datail/:id',
        element: (<RoleProtectedRoute roles={["Admin"]}> <StaffDetailsCard/> </RoleProtectedRoute>)
},
  {
        path: 'specializations-details/:id',
        element: <SpecializationsDetail />
  }

    ]
  },
  {
    path: '/components',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      }
    ]
  },
    {
    path: '/home',
    element: <HomeScreen />,
    children: [
      {
        path: '',
        element: <Navigate to="buttons" replace />
      }
    ]
  }
];

export default routes;
